/**
 * Vista: Impresión de Entrega de Tractor
 * Formato: AMX-VTA-FR-07_R8
 * Layout: 2 páginas
 */

import ventasService from '../services/ventas.service.js';

const NIVEL_A_SEGMENTO = { 'min': 1, 'bajo': 2, 'medio_bajo': 3, 'medio': 4, 'medio_alto': 5, 'alto': 6, 'max': 7 };

const FLUIDOS_COLORES = {
  combustible:               { 1:'red', 4:'yellow', 7:'green' },
  aceite_sistema_hidraulico: { 1:'red', 4:'green', 5:'green', 7:'red' },
  aceite_motor:              { 1:'red', 4:'green', 5:'green', 7:'red' },
  aceite_transmision:        { 1:'red', 4:'green', 5:'green', 7:'red' },
  aceite_sistema_direccion:  { 1:'red', 4:'green', 5:'green', 7:'red' },
  anticongelante:            { 1:'red', 4:'green', 5:'green', 7:'red' },
  aceite_frenos:             { 1:'red', 4:'green', 5:'green', 7:'red' }
};

const FLUIDO_KEY_MAP = {
  'nivel de combustible': 'combustible',
  'nivel de aceite de sistema hidráulico': 'aceite_sistema_hidraulico',
  'nivel de aceite de motor': 'aceite_motor',
  'nivel de aceite de transmisión': 'aceite_transmision',
  'nivel de aceite de sistema de dirección': 'aceite_sistema_direccion',
  'nivel de anticongelante': 'anticongelante',
  'nivel de aceite de frenos': 'aceite_frenos'
};

const TAPON_NAMES = {
  'nivel de combustible': 'TAPÓN DE COMBUSTIBLE',
  'nivel de aceite de sistema hidráulico': 'TAPÓN Y BALLONETA DE SISTEMA HIDRÁULICO',
  'nivel de aceite de motor': 'TAPÓN Y BALLONETA DE ACEITE DE MOTOR',
  'nivel de aceite de transmisión': 'TAPÓN Y BALLONETA DE ACEITE DE TRANSMISIÓN',
  'nivel de aceite de sistema de dirección': 'TAPÓN Y BALLONETA DE SISTEMA DIRECCIÓN',
  'nivel de anticongelante': 'TAPÓN DE ANTICONGELANTE',
  'nivel de aceite de frenos': 'TAPÓN DE ACEITE DE FRENOS'
};

export default {
  async render() {
    return `<div id="printContent" style="text-align: center; padding: 2rem;">Cargando formato de entrega...</div>`;
  },

  async afterRender(params) {
    try {
      const id = params.id;
      const response = await ventasService.obtenerEntrega(id);
      const entrega = response.data || response;
      this.renderPrint(entrega);
      this.fitToViewport();
      setTimeout(() => window.print(), 500);
    } catch (error) {
      document.getElementById('printContent').innerHTML = `
        <div style="color: red; padding: 2rem;">Error al cargar entrega: ${error.message}</div>
      `;
    }
  },

  formatFecha(fecha) {
    if (!fecha) return '';
    const str = typeof fecha === 'string' ? fecha : fecha.toISOString();
    const [y, m, d] = str.substring(0, 10).split('-');
    return `${d}/${m}/${y}`;
  },

  fitToViewport() {
    const container = document.querySelector('.ep');
    if (!container) return;
    const pageWidth = 748; // 198mm ≈ 748px
    const vw = document.documentElement.clientWidth;
    if (vw < pageWidth) {
      container.style.zoom = vw / pageWidth;
    }
  },

  renderPrint(e) {
    const html = this.generateHTML(e);
    document.getElementById('content').innerHTML = html;
  },

  renderFluidoSegments(f) {
    const key = FLUIDO_KEY_MAP[(f.fluido || '').toLowerCase()] || '';
    const colores = FLUIDOS_COLORES[key] || {};
    const segActivo = NIVEL_A_SEGMENTO[f.nivel] || 0;

    const segs = [1, 2, 3, 4, 5, 6, 7].map(seg => {
      const isActive = segActivo === seg;
      const colorClass = colores[seg] ? `seg-${colores[seg]}` : '';
      const activeClass = isActive ? 'active' : '';
      return `<div class="ep-fluido-seg ${colorClass} ${activeClass}"></div>`;
    }).join('');

    return `
      <div class="ep-fluido-row">
        <div class="ep-fluido-title">${(f.fluido || '').toUpperCase()}</div>
        <div class="ep-fluido-segments">${segs}</div>
        <div class="ep-fluido-labels"><span>Min</span><span>Max</span></div>
      </div>
    `;
  },

  renderFluidoWithTapon(f, chk) {
    const key = FLUIDO_KEY_MAP[(f.fluido || '').toLowerCase()] || '';
    const colores = FLUIDOS_COLORES[key] || {};
    const segActivo = NIVEL_A_SEGMENTO[f.nivel] || 0;
    const taponName = TAPON_NAMES[(f.fluido || '').toLowerCase()] || '';

    const segs = [1, 2, 3, 4, 5, 6, 7].map(seg => {
      const isActive = segActivo === seg;
      const colorClass = colores[seg] ? `seg-${colores[seg]}` : '';
      const activeClass = isActive ? 'active' : '';
      return `<div class="ep-fluido-seg ${colorClass} ${activeClass}">${isActive ? 'X' : ''}</div>`;
    }).join('');

    return `
      <div class="ep-fluido-with-tapon">
        <div class="ep-fluido-row">
          <div class="ep-fluido-title">${(f.fluido || '').toUpperCase()}</div>
          <div class="ep-fluido-segments">${segs}</div>
          <div class="ep-fluido-labels"><span>Min</span><span>Max</span></div>
        </div>
        <div class="ep-tapon-check">
          <span class="ep-check-box">${chk(f.tapon_verificado)}</span>
          <span class="ep-tapon-name">${taponName}</span>
        </div>
      </div>
    `;
  },

  generateHTML(e) {
    const chk = (val) => val ? '☑' : '☐';

    // Parse JSON arrays
    const inspeccion = Array.isArray(e.inspeccion_fisica) ? e.inspeccion_fisica : [];
    const sistemas = Array.isArray(e.funcionamiento_sistema) ? e.funcionamiento_sistema : [];
    const cabinaItems = Array.isArray(e.cabina) ? e.cabina : [];
    const indicaciones = Array.isArray(e.indicaciones_manual) ? e.indicaciones_manual : [];
    const fluidos = Array.isArray(e.niveles_fluidos) ? e.niveles_fluidos : [];
    const marcas = Array.isArray(e.marcas_visuales) ? e.marcas_visuales : [];
    // Convierte marca a HTML preservando radius_pct (diámetro = 2× radius_pct).
    // Marcas viejas sin radius_pct: tamaño default 5% (= 2.5% radius).
    const renderMark = (m) => {
      const r = (typeof m.radius_pct === 'number' && m.radius_pct > 0) ? m.radius_pct : 2.5;
      const w = (r * 2).toFixed(2);
      return `<div class="ep-mark" style="left:${m.x}%; top:${m.y}%; width:${w}%;"></div>`;
    };

    return `
      <style>
        @media print {
          body, html { margin: 0; padding: 0; }
          .sidebar, .navbar, nav, #sidebar, #navbarUser, .navbar-container { display: none !important; }
          .main-content, .main-layout, #app, #content {
            margin-left: 0 !important;
            padding: 0 !important;
            max-width: 100% !important;
            display: block !important;
          }
          .ep { zoom: 1 !important; }
          @page { size: portrait; margin: 5mm; }
        }

        .ep {
          font-family: Arial, Helvetica, sans-serif;
          font-size: 8.5pt;
          color: #000;
          width: 198mm;
          max-width: 198mm;
          margin: 0 auto;
          padding: 2mm 4mm;
          background: #fff;
          line-height: 1.3;
        }
        .ep * { box-sizing: border-box; margin: 0; padding: 0; }

        /* HEADER */
        .ep-header {
          display: grid;
          grid-template-columns: 100px 1fr 100px;
          align-items: center;
          margin-bottom: 4px;
        }
        .ep-header img { height: 30px; }
        .ep-header-center {
          text-align: center;
          font-size: 16pt;
          font-weight: bold;
          color: #1a4fa0;
        }
        .ep-header-right { text-align: right; }

        /* DATOS */
        .ep-datos {
          padding: 4px 8px;
          margin-bottom: 6px;
          font-size: 8pt;
        }
        .ep-datos-row {
          display: flex;
          gap: 10px;
          padding: 1px 0;
        }
        .ep-datos-field {
          display: flex;
          align-items: baseline;
          white-space: nowrap;
        }
        .ep-datos-field label {
          color: #1a4fa0;
          font-weight: bold;
          font-size: 8pt;
          margin-right: 2px;
        }
        .ep-datos-field .ep-datos-line {
          flex: 1;
          border-bottom: 1px solid #000;
          min-width: 30px;
          font-size: 8pt;
          padding-bottom: 1px;
        }

        /* TITLE SECTION */
        .ep-section-title {
          font-size: 10pt;
          font-weight: bold;
          text-align: center;
          padding: 4px 0;
          margin-bottom: 4px;
          color: #1a4fa0;
          border-bottom: 3px solid #1a4fa0;
        }

        /* 2 COLUMNS LAYOUT */
        .ep-columns {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 4px;
          padding: 4px;
          margin-bottom: 6px;
        }
        .ep-col-left {
          padding-right: 6px;
        }
        .ep-col-right {
          padding-left: 6px;
        }

        /* CHECK ITEMS */
        .ep-check-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0.5px 0;
          font-size: 7.5pt;
          border-bottom: 1px dotted #ccc;
        }
        .ep-check-item:last-child { border-bottom: none; }
        .ep-check-box {
          font-size: 10pt;
          min-width: 16px;
          text-align: center;
        }

        /* SUBSECTION */
        .ep-subsection {
          font-size: 8.5pt;
          font-weight: bold;
          margin: 6px 0 2px;
          color: #1a4fa0;
        }
        .ep-subsection-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 0 8px;
        }

        /* FLUIDOS */
        .ep-fluido-with-tapon {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 1px 0;
        }
        .ep-fluido-with-tapon .ep-fluido-row {
          flex: 0 0 140px;
        }
        .ep-tapon-check {
          display: flex;
          align-items: center;
          gap: 2px;
          font-size: 7pt;
        }
        .ep-tapon-name {
          font-size: 6pt;
          white-space: nowrap;
        }
        .ep-fluido-row {
          display: flex;
          flex-direction: column;
          gap: 1px;
          padding: 2px 0;
          font-size: 7pt;
        }
        .ep-fluido-title {
          font-weight: bold;
          text-transform: uppercase;
          font-size: 6.5pt;
          margin-bottom: 1px;
        }
        .ep-fluido-segments {
          display: flex;
          gap: 1px;
        }
        .ep-fluido-seg {
          width: 14px;
          height: 18px;
          border: 1.5px solid #999;
          border-radius: 2px;
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 8pt;
          font-weight: bold;
          color: #000;
        }
        .ep-fluido-seg.active { }
        .ep-fluido-seg.seg-red { background: #dc3545; border-color: #dc3545; print-color-adjust: exact; -webkit-print-color-adjust: exact; }
        .ep-fluido-seg.seg-yellow { background: #ffc107; border-color: #ffc107; print-color-adjust: exact; -webkit-print-color-adjust: exact; }
        .ep-fluido-seg.seg-green { background: #28a745; border-color: #28a745; print-color-adjust: exact; -webkit-print-color-adjust: exact; }
        .ep-fluido-seg.active.seg-red { }
        .ep-fluido-seg.active.seg-yellow { }
        .ep-fluido-seg.active.seg-green { }
        .ep-fluido-labels {
          display: flex;
          justify-content: space-between;
          font-size: 5pt;
          color: #666;
          width: 102px;
        }

        /* OBSERVACIONES */
        .ep-obs {
          padding: 0;
          margin: 0;
          font-size: 8pt;
          color: #000;
          line-height: 18px;
        }
        .ep-obs-title {
          font-size: 9pt;
          font-weight: bold;
          color: #1a4fa0;
          margin-bottom: 2px;
        }

        /* FOOTER */
        .ep-footer {
          display: grid;
          grid-template-columns: repeat(6, 1fr);
          border: 1px solid #1a4fa0;
          font-size: 6.5pt;
          text-align: center;
          margin-top: 4px;
        }
        .ep-footer > div {
          border-right: 1px solid #1a4fa0;
          padding: 2px;
        }
        .ep-footer > div:last-child { border-right: none; }
        .ep-footer-label { font-weight: bold; background: #1a4fa0; color: #fff; }
        .ep-footer-value { color: #1a4fa0; }

        /* PAGE 2 */
        .ep-page2 {
          page-break-before: always;
          font-family: Arial, Helvetica, sans-serif;
          font-size: 8.5pt;
          color: #000;
          width: 198mm;
          max-width: 198mm;
          margin: 0 auto;
          padding: 2mm 4mm;
          background: #fff;
        }
        .ep-page2 * { box-sizing: border-box; margin: 0; padding: 0; }

        .ep-visual-box {
          padding: 8px;
          margin-bottom: 8px;
        }
        .ep-visual-layout {
          display: flex;
          gap: 8px;
          align-items: flex-start;
          margin: 10px 0;
        }
        .ep-visual-main-imgs {
          flex: 1;
          display: flex;
          gap: 8px;
          align-items: center;
          justify-content: center;
        }
        .ep-visual-main-imgs img {
          max-height: 220px;
          object-fit: contain;
        }
        .ep-visual-cabin-box {
          flex: 0 0 auto;
          border: 2px solid #1a4fa0;
          padding: 6px;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .ep-visual-cabin-box-label {
          font-size: 7pt;
          font-weight: bold;
          color: #1a4fa0;
          margin-bottom: 4px;
        }
        .ep-visual-cabin-box .ep-img-container {
          margin-bottom: 6px;
        }
        .ep-visual-cabin-box img {
          max-height: 110px;
          object-fit: contain;
          display: block;
          margin: 0 auto;
        }
        .ep-img-container {
          position: relative;
          display: inline-block;
        }
        .ep-mark {
          position: absolute;
          aspect-ratio: 1;
          border: 2px solid #dc3545;
          border-radius: 50%;
          background: rgba(220, 53, 69, 0.25);
          transform: translate(-50%, -50%);
          print-color-adjust: exact;
          -webkit-print-color-adjust: exact;
        }

        /* OBSERVATION LINES */
        .ep-obs-lines {
          margin-bottom: 6px;
          padding: 0;
        }
        .ep-obs-line {
          border-bottom: 1px solid #000;
          height: 18px;
          display: flex;
          align-items: flex-end;
          line-height: 1.2;
        }

        /* FIRMAS */
        .ep-firmas {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 30px;
          margin-top: 30px;
          text-align: center;
        }
        .ep-firma-line {
          border-top: 1px solid #000;
          padding-top: 4px;
          font-size: 9pt;
          font-weight: bold;
          color: #1a4fa0;
        }
        .ep-firma-sub {
          font-size: 7.5pt;
          font-weight: normal;
          color: #1a4fa0;
        }
        .ep-firma-img {
          max-width: 180px;
          max-height: 80px;
          margin: 0 auto 4px;
        }

        .ep-crm {
          text-align: right;
          margin-top: 15px;
          font-size: 9pt;
        }
        .ep-crm-label {
          font-weight: bold;
          color: #ef4444;
          font-size: 8pt;
          padding: 2px 8px;
          display: inline-block;
          margin-right: 4px;
        }
      </style>

      <!-- ==================== PÁGINA 1 ==================== -->
      <div class="ep">
        <!-- Header -->
        <div class="ep-header">
          <div><img src="/img/Logo _LOVOL.png" alt="LOVOL" onerror="this.style.display='none'" /></div>
          <div class="ep-header-center">ENTREGA DE TRACTOR</div>
          <div class="ep-header-right"><img src="/img/Logo_AGRO.png" alt="AGROMX" onerror="this.style.display='none'" /></div>
        </div>

        <!-- Datos del tractor -->
        <div class="ep-datos">
          <div class="ep-datos-row">
            <div class="ep-datos-field" style="flex: 5;">
              <label>Número de serie:</label>
              <span class="ep-datos-line">${e.num_serie || ''}</span>
            </div>
            <div class="ep-datos-field" style="flex: 3;">
              <label>Modelo:</label>
              <span class="ep-datos-line">${e.modelo || ''}</span>
            </div>
            <div class="ep-datos-field" style="flex: 2;">
              <label>Horas motor:</label>
              <span class="ep-datos-line">${e.horas_motor || ''}</span>
            </div>
          </div>
          <div class="ep-datos-row">
            <div class="ep-datos-field" style="flex: 5;">
              <label>Usuario:</label>
              <span class="ep-datos-line">${e.usuario || ''}</span>
            </div>
            <div class="ep-datos-field" style="flex: 5;">
              <label>Fecha:</label>
              <span class="ep-datos-line">${this.formatFecha(e.fecha)}</span>
            </div>
          </div>
        </div>

        <!-- Título -->
        <div class="ep-section-title">PUNTOS DE INSPECCIÓN FÍSICA</div>

        <!-- 2 Columnas principales -->
        <div class="ep-columns">
          <!-- Columna izquierda: Inspección física -->
          <div class="ep-col-left">
            ${inspeccion.map(i => `
              <div class="ep-check-item">
                <span>${(i.item || '').toUpperCase()}</span>
                <span class="ep-check-box">${chk(i.verificado)}</span>
              </div>
            `).join('')}
          </div>

          <!-- Columna derecha -->
          <div class="ep-col-right">
            <!-- Sistemas -->
            <div class="ep-subsection">FUNCIONAMIENTO DE SISTEMA</div>
            <div class="ep-subsection-grid">
              ${sistemas.map(s => `
                <div class="ep-check-item">
                  <span>${(s.sistema || '').toUpperCase()}</span>
                  <span class="ep-check-box">${chk(s.verificado)}</span>
                </div>
              `).join('')}
            </div>

            <!-- Cabina -->
            <div class="ep-subsection" style="margin-top: 10px;">CABINA</div>
            <div class="ep-subsection-grid">
              ${cabinaItems.map(c => `
                <div class="ep-check-item">
                  <span>${(c.item || '').toUpperCase()}</span>
                  <span class="ep-check-box">${chk(c.verificado)}</span>
                </div>
              `).join('')}
            </div>

            <!-- Indicaciones Manual -->
            <div style="margin-top: 18px;"></div>
            ${indicaciones.map(m => `
              <div class="ep-check-item">
                <span class="ep-check-box">${chk(m.verificado)}</span>
                <span style="flex: 1; margin-left: 4px;">${(m.item || '').toUpperCase()}</span>
              </div>
            `).join('')}

            <!-- Niveles de Fluidos + Tapones -->
            <div style="margin-top: 14px;"></div>
            ${fluidos.map(f => this.renderFluidoWithTapon(f, chk)).join('')}
          </div>
        </div>

        <!-- Observaciones -->
        <div class="ep-obs-title">OBSERVACIONES</div>
        <div style="border-bottom: 3px solid #1a4fa0; margin-bottom: 2px;"></div>
        ${e.observaciones
          ? `<div class="ep-obs-line" style="font-size: 8pt; color: #000;">${e.observaciones}</div><div class="ep-obs-line"></div><div class="ep-obs-line"></div>`
          : '<div class="ep-obs-line"></div><div class="ep-obs-line"></div><div class="ep-obs-line"></div>'
        }

        <!-- Footer -->
        <div class="ep-footer">
          <div>
            <div class="ep-footer-label">CÓDIGO</div>
            <div class="ep-footer-value">AMX-VTA-FR-07_R8</div>
          </div>
          <div>
            <div class="ep-footer-label">REVISIÓN</div>
            <div class="ep-footer-value">8</div>
          </div>
          <div>
            <div class="ep-footer-label">FECHA DE PUBLICACIÓN</div>
            <div class="ep-footer-value">Agosto 2025</div>
          </div>
          <div>
            <div class="ep-footer-label">SUSTITUYE</div>
            <div class="ep-footer-value">AMX-VTA-FR-06_R7</div>
          </div>
          <div>
            <div class="ep-footer-label">VIGENCIA</div>
            <div class="ep-footer-value">Agosto 2025 al 2027</div>
          </div>
          <div>
            <div class="ep-footer-label">PAGINA 1 DE 2</div>
            <div class="ep-footer-value"></div>
          </div>
        </div>
      </div>

      <!-- ==================== PÁGINA 2 ==================== -->
      <div class="ep-page2">
        <!-- Header -->
        <div class="ep-header">
          <div><img src="/img/Logo _LOVOL.png" alt="LOVOL" onerror="this.style.display='none'" /></div>
          <div class="ep-header-center">INSPECCIÓN VISUAL</div>
          <div class="ep-header-right"><img src="/img/Logo_AGRO.png" alt="AGROMX" onerror="this.style.display='none'" /></div>
        </div>

        <div style="border-bottom: 3px solid #1a4fa0; margin-bottom: 4px;"></div>
        <!-- Inspección Visual -->
        <div class="ep-visual-box">
          <p style="font-size: 8pt; margin-bottom: 6px; color: #1a4fa0;">Revisión visual del estado físico del tractor LOVOL</p>

          <div class="ep-visual-layout">
            <div class="ep-visual-main-imgs">
              <div class="ep-img-container">
                <img src="/img/tractor-lateral-der.jpeg" alt="Lateral Derecho" onerror="this.parentElement.style.display='none'" />
                ${marcas.filter(m => m.img === 'tractor-lateral-der').map(renderMark).join('')}
              </div>
              <div class="ep-img-container">
                <img src="/img/tractor-lateral-izq.jpeg" alt="Lateral Izquierdo" onerror="this.parentElement.style.display='none'" />
                ${marcas.filter(m => m.img === 'tractor-lateral-izq').map(renderMark).join('')}
              </div>
            </div>
            <div class="ep-visual-cabin-box">
              <div class="ep-visual-cabin-box-label">Para tractor encabinado</div>
              <div class="ep-img-container">
                <img src="/img/tractor-frente.jpeg" alt="Parte Frontal" onerror="this.parentElement.style.display='none'" />
                ${marcas.filter(m => m.img === 'tractor-frente').map(renderMark).join('')}
              </div>
              <div class="ep-img-container">
                <img src="/img/tractor-trasera.jpeg" alt="Parte Trasera" onerror="this.parentElement.style.display='none'" />
                ${marcas.filter(m => m.img === 'tractor-trasera').map(renderMark).join('')}
              </div>
            </div>
          </div>

          <p style="font-size: 6.5pt; color: #1a4fa0;">*El diagrama es ilustrativo, y las características del tractor pueden variar según modelo.</p>
        </div>

        <!-- Observaciones Visual -->
        <div class="ep-section-title" style="border-bottom: 2px solid #1a4fa0; margin-bottom: 0;">OBSERVACIONES</div>
        <div class="ep-obs-lines" style="margin-top: 18px;">
          ${e.observaciones_visual
            ? `<div class="ep-obs-line" style="font-size: 8pt; color: #000;">${e.observaciones_visual}</div>${Array.from({ length: 7 }, () => '<div class="ep-obs-line"></div>').join('')}`
            : Array.from({ length: 8 }, () => '<div class="ep-obs-line"></div>').join('')
          }
        </div>

        <!-- Firmas -->
        <div class="ep-firmas">
          <div>
            ${e.firma_distribuidor_url ? `<img src="${e.firma_distribuidor_url}" class="ep-firma-img" />` : '<div style="height: 60px;"></div>'}
            ${e.distribuidor ? `<div style="font-size: 8pt; color: #000;">${e.distribuidor}</div>` : ''}
            <div class="ep-firma-line">DISTRIBUIDOR</div>
            <div class="ep-firma-sub">Nombre y firma</div>
          </div>
          <div>
            ${e.firma_usuario_url ? `<img src="${e.firma_usuario_url}" class="ep-firma-img" />` : '<div style="height: 60px;"></div>'}
            ${e.usuario ? `<div style="font-size: 8pt; color: #000;">${e.usuario}</div>` : ''}
            <div class="ep-firma-line">USUARIO</div>
            <div class="ep-firma-sub">Nombre y firma</div>
          </div>
        </div>

        <!-- Reporte CRM -->
        <div class="ep-crm">
          <span style="display: inline-flex; align-items: baseline; gap: 2px;">
            <span class="ep-crm-label">REPORTE CRM</span>
            <span style="color: #000; border-bottom: 1px solid #000; display: inline-block; padding: 0 4px 1px; min-width: 120px; text-align: left;">${e.reporte_crm || ''}</span>
          </span>
        </div>
        <div style="border-bottom: 3px solid #1a4fa0; margin-top: 25px;"></div>

        <!-- Footer -->
        <div class="ep-footer" style="margin-top: 20px;">
          <div>
            <div class="ep-footer-label">CÓDIGO</div>
            <div class="ep-footer-value">AMX-VTA-FR-07_R8</div>
          </div>
          <div>
            <div class="ep-footer-label">REVISIÓN</div>
            <div class="ep-footer-value">8</div>
          </div>
          <div>
            <div class="ep-footer-label">FECHA DE PUBLICACIÓN</div>
            <div class="ep-footer-value">Agosto 2025</div>
          </div>
          <div>
            <div class="ep-footer-label">SUSTITUYE</div>
            <div class="ep-footer-value">AMX-VTA-FR-06_R7</div>
          </div>
          <div>
            <div class="ep-footer-label">VIGENCIA</div>
            <div class="ep-footer-value">Agosto 2025 al 2027</div>
          </div>
          <div>
            <div class="ep-footer-label">PAGINA 2 DE 2</div>
            <div class="ep-footer-value"></div>
          </div>
        </div>
      </div>
    `;
  }
};
